
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HiddenInput extends Vue {
  showValue = false;

  validate() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (this.$refs.input as any).validate();
  }
}
